var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 256,
    viewBox: "0 0 304 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.042 22.7195L296.088 180.381C317.273 213.112 293.428 256 254.047 256H49.9534C10.5716 256 -13.2731 213.112 7.9116 180.381L109.958 22.7195C129.565 -7.57317 174.435 -7.57314 194.042 22.7195ZM181.047 30.8948C167.5 9.96535 136.5 9.96534 122.953 30.8948L20.9063 188.557C6.26961 211.17 22.7441 240.802 49.9534 240.802H254.047C281.256 240.802 297.73 211.17 283.094 188.557L181.047 30.8948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.0ffdf0a92600a0b22051da6db6e594ec.svg";
export { ForwardRef as ReactComponent };